import './MenuItem.css';

export default function MenuItem({ item }) {
  return (
    <article className="mi">
      <div className="mi__row">
        <h4 className="mi__name">{item.name}</h4>
        <span className="mi__leader" aria-hidden="true"></span>
        <span className="mi__price">Call for pricing</span>
      </div>
      <p className="mi__desc">{item.description}</p>
      {item.variants && (
        <ul className="mi__variants" aria-label="Available with">
          {item.variants.map((v) => (
            <li key={v}>{v}</li>
          ))}
        </ul>
      )}
    </article>
  );
}
